import { render, staticRenderFns } from "./AddEdtChnlDlg.vue?vue&type=template&id=260917a8"
import script from "./AddEdtChnlDlg.vue?vue&type=script&lang=js"
export * from "./AddEdtChnlDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports